// extracted by mini-css-extract-plugin
export default {"page_bar":"page-bar_page_bar__PWpRW","title":"page-bar_title__z4mop"};